export default __webpack_public_path__ + "static/mc-f4def35344af921291053e1dcd0fee43.png";